
      export default {
        functional: true,
        render(_h, _vm) {
          const { _c, _v, data, children = [] } = _vm;

          const {
            class: classNames,
            staticClass,
            style,
            staticStyle,
            attrs = {},
            ...rest
          } = data;

          return _c(
            'svg',
            {
              class: [classNames,staticClass],
              style: [style,staticStyle],
              attrs: Object.assign({"xmlns":"http://www.w3.org/2000/svg","width":"60","height":"60"}, attrs),
              ...rest,
            },
            children.concat([_c('path',{attrs:{"fill":"none","stroke":"#241f21","stroke-miterlimit":"10","stroke-width":"2","d":"M13.01 21.75H27.5M13 15v6.71l-8.73 11v26H41.5v-7c0-11-5-14-9-19s-5-6-5-11v-7M32 12.75a9 9 0 009 9M4 40.75h35"}}),_c('circle',{attrs:{"cx":"54.5","cy":"2.75","r":"1.5","fill":"#241f21"}}),_c('circle',{attrs:{"cx":"47.5","cy":"6.75","r":"1.5","fill":"#241f21"}}),_c('circle',{attrs:{"cx":"54.5","cy":"10.75","r":"1.5","fill":"#241f21"}}),_c('path',{attrs:{"fill":"none","stroke":"#241f21","stroke-miterlimit":"10","stroke-width":"2","d":"M20 21.75v32M40 4.46H12.47L4 15.04h23.29L40 9.75V4.46zM34.71 4.46v7.41"}})])
          )
        }
      }
    